import { TreeItem, treeItemClasses } from '@mui/x-tree-view'
import { styled } from '@mui/material/styles';

const CustomTreeItem = styled(({...props}) => (
  <TreeItem {...props}/>
  ))(({ theme }) => ({
    [`& .${treeItemClasses.group}`]: { borderLeft: `1px dashed`, borderColor: '#808080', marginLeft: '15px' },
    [`& .${treeItemClasses.label}`]: { overflow: 'hidden' },
    [`& .${treeItemClasses.content}`]: { padding: '0px 0px 0px 8px' },
    [`& .${treeItemClasses.iconContainer}`]: { pointerEvents: 'auto' },
  }));
  
  export default CustomTreeItem
